import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { WORK_OS_IRIS_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME } from "styles/color-consts";
export const PRODUCT_ID_TO_LOGO = {
    [WORK_MANAGEMENT_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/wm-logo.png",
    [CRM_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/crm-logo.png",
    [DEV_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/dev-logo.png"
};
export const PRODUCT_ID_TO_COLOR = {
    [WORK_MANAGEMENT_PRODUCT_ID]: WORK_OS_IRIS_COLOR_NAME,
    [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
    [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
export const BUTTON_CONFIG_BY_PRODUCT = {
    [WORK_MANAGEMENT_PRODUCT_ID]: {
        signupProductId: WORK_MANAGEMENT_PRODUCT_ID
    },
    [CRM_PRODUCT_ID]: {
        signupProductId: CRM_PRODUCT_ID
    },
    [DEV_PRODUCT_ID]: {
        signupProductId: DEV_PRODUCT_ID
    }
};
